


























































































































































































































































import Vue from 'vue'
import { Tag } from '@/types/tag.d'
import { SelectOptions } from './types'
const vueJsonEditor = require('vue-json-editor').default

export default Vue.extend({
  props: {
    value: Object,
    devices: Array,
  },
  components: {
    vueJsonEditor,
  },
  data() {
    return {
      optsDevice: [] as SelectOptions[],
      // tags: [] as Tag[],
      model: {
        id: 0,
        type: '',
        conversion: '',
        eu: '',
        scaling: false,
        inMin: 0,
        inMax: 0,
        outMin: 0,
        outMax: 0,
        name: '',
        address: '',
        deviceId: 0,
        description: '',
        uid: '',
        groupUid: '',
        attributes: {},
        html: {},
        normal: {},
        precision: 0,
        good: false,
        value: 0,
      } as Tag,
      computes: [
        {
          math: false,
          type: 'Const',
          value: 12,
        },
      ],
    }
  },

  methods: {
    onJsonChange() {
      //
    },
    addCompute() {
      const computes = this.computes
      const last = computes[computes.length - 1]

      if (last.math) {
        computes.push({
          math: false,
          type: '',
          value: 0,
        })
      } else {
        computes.push({
          math: true,
          type: '+',
          value: 0,
        })
      }
    },
  },

  watch: {
    devices: function(value: SelectOptions[]) {
      this.optsDevice = value
    },

    value: function(val: Tag) {
      this.model = val
    },
  },
})
